define('views/modules/calendar/animated-session/animation/rename/list/custom-name-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // views
    'views/parts/media-info-box',
    // templates
    'text!templates/modules/calendar/animated-session/animation/rename/list/custom-name-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // views
    VMediaInfoBox,
    // templates
    TCustomNameListItem
) {

    var VCustomNameListItem = Backbone.View.extend({
        template: TCustomNameListItem,

        regions: {
            infobox: ".item-section",
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    subtitle: 'description',
                    model: this.model,
                    context: this,
                    onClick: this.onCustomNameClick,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
            };

            this.listenTo(this.model, {
                'remove': this.remove,
            });
        },
        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones()
                .assign(this.view.infobox, this.regions.infobox);
            // needs menu regions from infobox el

            return this;
        },

        deleteCustomName: function(result) {
            if (!result) return;
            this.model.destroy({
                context: this,
                wait: true,
                error: function(model, response) {
                    if (response.responseJSON) {
                        U.warn(response.responseJSON.message);
                    }
                }
            });

        },

        ////////////
        // events //
        ////////////

        onMenuInit: function() {
            var menuActions = new Backbone.Collection([
                { caption: 'Delete', icon: "sl-icon-trash", callback: this.onDeleteAction }
            ]);

            return menuActions;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onCustomNameClick: function(e) {
            this.model.trigger('custom:name:click', this.model);
        },

        onDeleteAction: function() {
            Bootbox.confirm({
                title: "Delete custom name",
                message: "messages:message-delete-custom-exercise-name",
                onEscape: true,
                backdrop: true,
                callback: this.deleteCustomName,
                context: this,
            });
        },

    });

    return VCustomNameListItem;

});

